/**
 * Options and display labels for `FormField.type`, used by the form builder's "Field Type"
 * dropdown and any copy that names a field's type (e.g. the type-change confirmation dialog).
 */

/** Options for the form builder's "Field Type" dropdown, in display order. */
export const FIELD_TYPE_OPTIONS: { value: string; label: string }[] = [
  { value: "text", label: "Text" },
  { value: "tel", label: "Phone" },
  { value: "date", label: "Date" },
  { value: "time", label: "Time" },
  { value: "number", label: "Number" },
  { value: "scale", label: "Rating / Scale" },
  { value: "dropdown", label: "Dropdown" },
  { value: "multiplechoice", label: "Multiple Choice" },
  { value: "multiselect", label: "Multi-select" },
  { value: "ranking", label: "Ranking" },
  { value: "file", label: "File Upload" },
  { value: "address", label: "Address" },
];

/** Human-readable label for a field type, keyed by `FormField.type`. */
export const FIELD_TYPE_LABELS: Record<string, string> = Object.fromEntries(
  FIELD_TYPE_OPTIONS.map((option) => [option.value, option.label])
);

/**
 * Most options a numeric scale can have and still stretch to fill the row on phones.
 * Past this (e.g. a 0 to 10 scale) the buttons would get too narrow to tap, so they stay compact and wrap.
 */
export const SCALE_STRETCH_MAX_OPTIONS = 7;

/**
 * Choice count at which a multi-select shown as a dropdown gets a search box. Below this the whole
 * list fits in the menu at a glance, so typing to filter only adds a step.
 */
export const MULTISELECT_DROPDOWN_SEARCH_MIN_CHOICES = 8;
